/* src/app/components/article-option-group-custom/article-option-group-custom.component.scss */
:host {
  width: 100%;
}
.wrapper {
  padding: 0;
  width: 100%;
}
.wrapper .wrapper-articles {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 14px;
  width: 100%;
  padding: 0px;
}
@media (max-width: 992px) {
  .wrapper .wrapper-articles {
    gap: 10px;
  }
}
.wrapper .wrapper-articles .item-card {
  width: 100%;
  background: #23262c;
  border: 2px solid transparent;
  border-radius: 12px;
  padding: 16px;
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  transition: all 0.3s ease;
  margin: 0;
}
@media (max-width: 992px) {
  .wrapper .wrapper-articles .item-card {
    padding: 12px;
  }
}
.wrapper .wrapper-articles .item-card.selected {
  border-color: #00ffff;
}
.wrapper .wrapper-articles .item-card:hover {
  background: #2a2d35;
}
.wrapper .wrapper-articles .item-card ion-card-header {
  width: 100%;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  margin-bottom: 8px;
  min-height: 24px;
  padding: 0;
}
.wrapper .wrapper-articles .item-card ion-card-header .info-icon {
  width: 24px;
  height: 24px;
  color: rgba(255, 255, 255, 0.6);
  cursor: pointer;
  transition: color 0.2s;
}
@media (max-width: 992px) {
  .wrapper .wrapper-articles .item-card ion-card-header .info-icon {
    width: 20px;
    height: 20px;
  }
}
.wrapper .wrapper-articles .item-card ion-card-header .info-icon:hover {
  color: rgb(255, 255, 255);
}
.wrapper .wrapper-articles .item-card ion-card-header .spacer {
  flex: 1;
}
.wrapper .wrapper-articles .item-card ion-card-header .selected-icon {
  width: 24px;
  height: 24px;
}
@media (max-width: 992px) {
  .wrapper .wrapper-articles .item-card ion-card-header .selected-icon {
    width: 20px;
    height: 20px;
  }
}
.wrapper .wrapper-articles .item-card ion-card-content {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  padding: 0;
}
.wrapper .wrapper-articles .item-card ion-card-content .item-name {
  font-family: AppFont;
  font-size: 16px;
  line-height: 130%;
  color: #fff;
  text-align: center;
  text-transform: capitalize;
  margin: 0 0 16px 0;
  min-height: 42px;
  display: flex;
  align-items: center;
  justify-content: center;
}
@media (max-width: 992px) {
  .wrapper .wrapper-articles .item-card ion-card-content .item-name {
    font-size: 14px;
    margin: 0 0 12px 0;
    min-height: 36px;
  }
}
.wrapper .wrapper-articles .item-card ion-card-content .item-image-wrapper {
  width: 100%;
  height: 120px;
  display: flex;
  align-items: center;
  justify-content: center;
  margin-bottom: 16px;
}
@media (max-width: 992px) {
  .wrapper .wrapper-articles .item-card ion-card-content .item-image-wrapper {
    height: 100px;
    margin-bottom: 12px;
  }
}
.wrapper .wrapper-articles .item-card ion-card-content .item-image-wrapper .item-image {
  width: 100%;
  height: 100%;
  object-fit: contain;
}
.wrapper .wrapper-articles .item-card ion-card-content .item-image-wrapper .item-image.default-img {
  width: 60%;
  height: 60%;
  object-fit: contain;
  --icon-color: white;
}
.wrapper .wrapper-articles .item-card ion-card-content .item-price {
  font-family: AppFont;
  font-size: 16px !important;
  font-weight: 600;
  color: #fff;
  text-align: center;
  margin: 0 0 16px 0;
  min-height: 24px;
}
@media (max-width: 992px) {
  .wrapper .wrapper-articles .item-card ion-card-content .item-price {
    font-size: 18px;
    margin: 0 0 12px 0;
    min-height: 21px;
  }
}
.wrapper .wrapper-articles .item-card ion-card-content .item-price.item-price-zero {
  opacity: 0;
}
.wrapper .wrapper-articles .item-card ion-card-content .card-footer {
  width: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 48px;
}
@media (max-width: 992px) {
  .wrapper .wrapper-articles .item-card ion-card-content .card-footer {
    min-height: 40px;
  }
}
.wrapper .wrapper-articles .item-card ion-card-content .card-footer .add-icon {
  width: 14px;
  height: 14px;
  padding: 12px;
  flex: 0 0 auto;
  cursor: pointer;
  transition: transform 0.2s;
  color: #fff;
}
@media (max-width: 992px) {
  .wrapper .wrapper-articles .item-card ion-card-content .card-footer .add-icon {
    width: 14px;
    height: 14px;
    padding: 10px;
  }
}
.wrapper .wrapper-articles .item-card ion-card-content .card-footer .add-icon:hover {
  transform: scale(1.1);
}
.wrapper .wrapper-articles .item-card ion-card-content .card-footer .add-icon:active {
  transform: scale(0.95);
}
.wrapper .wrapper-articles .item-card ion-card-content .card-footer .quantity-selector {
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 16px;
  background: #383838;
  border: 2px solid #fff;
  border-radius: 28px;
  padding: 10px 24px;
  width: 100%;
  max-width: 180px;
  box-sizing: border-box;
}
@media (max-width: 992px) {
  .wrapper .wrapper-articles .item-card ion-card-content .card-footer .quantity-selector {
    gap: 8px;
    padding: 8px 10px;
    max-width: 100%;
  }
}
@media (max-width: 480px) {
  .wrapper .wrapper-articles .item-card ion-card-content .card-footer .quantity-selector {
    gap: 2px;
    padding: 7px 5px;
  }
}
.wrapper .wrapper-articles .item-card ion-card-content .card-footer .quantity-selector .quantity-btn {
  width: 20px;
  height: 20px;
  flex: 0 0 auto;
  cursor: pointer;
  transition: transform 0.2s;
  color: #fff;
}
@media (max-width: 992px) {
  .wrapper .wrapper-articles .item-card ion-card-content .card-footer .quantity-selector .quantity-btn {
    width: 16px;
    height: 16px;
  }
}
@media (max-width: 480px) {
  .wrapper .wrapper-articles .item-card ion-card-content .card-footer .quantity-selector .quantity-btn {
    width: 14px;
    height: 14px;
  }
}
.wrapper .wrapper-articles .item-card ion-card-content .card-footer .quantity-selector .quantity-btn:hover {
  transform: scale(1.2);
}
.wrapper .wrapper-articles .item-card ion-card-content .card-footer .quantity-selector .quantity-btn:active {
  transform: scale(0.9);
}
.wrapper .wrapper-articles .item-card ion-card-content .card-footer .quantity-selector .quantity-text {
  font-family: AppFont;
  font-size: 18px;
  color: #fff;
  min-width: 30px;
  text-align: center;
  flex: 1 1 auto;
}
@media (max-width: 992px) {
  .wrapper .wrapper-articles .item-card ion-card-content .card-footer .quantity-selector .quantity-text {
    font-size: 16px;
    min-width: 20px;
  }
}
@media (max-width: 480px) {
  .wrapper .wrapper-articles .item-card ion-card-content .card-footer .quantity-selector .quantity-text {
    font-size: 15px;
    min-width: 14px;
  }
}
.wrapper .button-show-more {
  width: 95%;
  padding: 5px 10px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid var(--ion-color-secondary);
  border-radius: 8px;
  margin: 20px auto 5px;
}
.wrapper .button-show-more p {
  color: var(--ion-color-secondary);
  font-size: 16px;
}
.wrapper .button-show-more .arrow-down {
  padding: 5px;
  border: 1px solid var(--ion-color-secondary);
  border-radius: 50%;
  width: 25px;
  height: 25px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: 5px;
  rotate: 0deg;
  transition: rotate 0.3s ease-in-out;
}
.wrapper .button-show-more .arrow-down.rotate {
  rotate: 540deg;
}
.back-icon {
  position: sticky;
  top: 50%;
  transform: translateY(-50%);
  left: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  border-radius: 50%;
  background: var(--ion-color-primary);
  z-index: 99;
  width: 30px;
  height: 30px;
  max-width: 30px;
  max-height: 30px;
}
.back-icon ion-icon {
  fill: white;
  color: white;
}
.next-icon {
  position: sticky;
  top: 50%;
  transform: translateY(-50%);
  right: 10px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 10px;
  border-radius: 50%;
  background: var(--ion-color-primary);
  z-index: 99;
  width: 30px;
  height: 30px;
  max-width: 30px;
  max-height: 30px;
}
.next-icon ion-icon {
  fill: white;
  color: white;
}
/*# sourceMappingURL=article-option-group-custom.component.css.map */
